import styled from "@emotion/styled";
import { MenuItem } from "react-aria-components";
import type { IMDSMenuItemProps, IFigmaMenuItemProps } from "./menu-item.types";

export const StyledMenuItem = styled(MenuItem)<IMDSMenuItemProps>(({ theme }) => ({
  // layout
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing.sm,
  padding: theme.spacing.sm,

  // typography
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.xsmall,

  // styling
  borderRadius: theme.borderRadius.medium,
  cursor: "pointer",
  color: theme.colors.text.primary,
  outline: "none",

  // Hover / focus
  "&:hover, &[data-hovered], &[data-focused]": {
    backgroundColor: theme.colors.background.menu.hover,
  },

  // Active / selected state
  "&[data-pressed], &[data-selected]": {
    backgroundColor: theme.colors.background.menu.selected,
  },

  // Disabled state
  "&[aria-disabled='true']": {
    pointerEvents: "none",
    color: theme.colors.text.tertiary,
    cursor: "default",
  },
}));

export const FigmaStyledMenuItem = styled(StyledMenuItem)<IFigmaMenuItemProps>(
  ({ theme, cursor }) => ({
    // layout
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing.sm,

    // typography
    fontSize: theme.fontSizes.small,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.xsmall,

    // styling
    borderRadius: theme.borderRadius.medium,
    cursor: cursor ?? "pointer",
    "&:hover": {
      backgroundColor: theme.colors.background.menu.hover,
    },
  })
);

export const StyledMenuItemLeft = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing.sm,
}));

export const StyledMenuItemRight = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing.sm,
}));
